import { format, parseISO } from 'date-fns'
import $api from '@/plugins/axiosInstance.js'
import CONST from '@/const.js'
import isEmpty from 'lodash/isEmpty'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  
//   GET_USER_WITHDRAWAL: {
//     root: true,
//     handler(namespacedContext, payload) {
//       return $api({ method: 'get', url: `/user/${payload.id}/withdrawal`, params: payload.params})
//         .then(result =>{return result})
//     }
//   },
//   POST_USER_WITHDRAWAL: {
//     root: true,
//     handler(namespacedContext, payload) {
//       return $api({ method: 'post', url: `/user/${payload.id}/withdrawal`,})
//         .then(result =>{return result})
//     }
//   },
//   REJECT_WITHDRAWAL: {
//     root: true,
//     handler(namespacedContext, payload){
//       return $api({method: "put", url: `/user/${payload.id}/withdrawal/${payload.withdrawal_id}/reject`, data: payload.params})
//       .then(result =>{
//         return result
//       })
//     }
//   },
//   GET_SETTLEMENT_EXCEL : {
//     root: true,
//     handler(namespacedContext, payload) {
//       return $api({ method: 'post', url: '/withdrawal/export-settlement',data :  payload, responseType: 'blob' })
//         .then(result =>{return result})
//     }
//   }

    GET_TRANSFER_LIST: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/transfer`, params: payload})
            .then(result =>{return result.data})
        }
    },
    GET_TRANSFER_DETAIL: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/transfer/${payload.id}`, params: payload.params})
            .then(result =>{return result.data})
        }
    },
    GET_TRANSFER_DETAIL_ALBUM: {
        root: true,
        handler(namespacedContext, payload) {
        return $api({ method: 'get', url: `/transfer/${payload.id}/album`, params: payload.params})
            .then(result =>{return result.data})
        }
    },
    POST_TRANSFER: {
        root: true,
        handler(namespacedContext, payload){
            return $api({method: "post", url:`/transfer`, data: payload.params})
            .then(result =>{
            return result
            })
        }
    },
    PUT_TRANSFER_DETAIL_MEMO: {
        root: true,
        handler(namespacedContext, payload){
            return $api({method: "put", url:`/transfer/${payload.id}`, data: payload.params})
            .then(result =>{
            return result.data
            })
        }
    },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
